import React, { useState, useContext } from 'react'
import { M_Table, LoadingContext, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

export default function BoardVehicle({ roles }) {

  const [line, setLine] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const { t } = useTranslation()

  const viewTransport = () => {
    if (line) {
      const current = ctx.passValue instanceof Map ? ctx.passValue : new Map()
      const newMap = new Map(current)
      newMap.set("lines", line[0])
      newMap.set("operation", "view")

      ctx.setPassValue(newMap)
      ctx2.newTab('createTransport', `${t("Tractor")} #${line[0].TransportId}`)
    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }


  return (
    <div>
      <M_Table
        entityName={'AvailableTransportBoardView'}
        rolePermissions={roles}
        filtersOnTable
        refresh={refresh}
        setRefresh={setRefresh}
        selectSingle
        onPassLine={(line) => {
          if (!line || (Array.isArray(line) && line.length === 0)) {
            setLine(null)
          } else {
            setLine(line)
          }
        }}
        extraButtons={[
          { label: t('ViewTransport'), element: 'default', source: '/icons/svgsDaNet/eye-blue.svg', style: {}, command: () => { viewTransport() } },
        ]}
      />
    </div>
  )
}